import React, { ReactElement } from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { MaterialSymbol } from '../../shared';
import { FEED_COLORS, FEED_FONT } from './feedTokens';

export interface FeedSectionHeaderProps {
  title: string;
  inset?: boolean;
  onViewMore?: () => void;
}

export const FeedSectionHeader = ({
  title,
  inset = false,
  onViewMore,
}: FeedSectionHeaderProps): ReactElement => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
      px: inset ? '16px' : 0,
    }}
  >
    <Typography
      component="h2"
      sx={{
        m: 0,
        fontFamily: FEED_FONT,
        fontWeight: 600,
        fontSize: '20px',
        lineHeight: '28px',
        color: FEED_COLORS.textPrimary,
      }}
    >
      {title}
    </Typography>
    {onViewMore && (
      <ButtonBase
        onClick={onViewMore}
        disableRipple
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '2px',
          flexShrink: 0,
          fontFamily: FEED_FONT,
          fontWeight: 500,
          fontSize: '16px',
          lineHeight: '24px',
          color: FEED_COLORS.textPrimary,
          borderRadius: '4px',
          '&:hover': { color: FEED_COLORS.navy },
          '&:focus-visible': {
            outline: `2px solid ${FEED_COLORS.textPrimary}`,
            outlineOffset: '2px',
          },
        }}
      >
        View more
        <MaterialSymbol name="chevron_right" size={20} />
      </ButtonBase>
    )}
  </Box>
);
